const PropertyGroupVisibilities = [
  { id: 'campaigns', name: 'Campaigns' },
  { id: 'slots', name: 'Slots' }
];

export default PropertyGroupVisibilities;



// WEBPACK FOOTER //
// ./src/views/StaticData/PropertyGroupVisibilities.tsx